import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import s from "../InterlinkingMain.module.css";
import { StateType } from "../../../redux/redux-store";
import { scrollToTop } from "../../../common/Logic/supporting";
import { getNearestList } from "../../../redux/category_Reducer";
import { CategoryWithTree } from "../../../types/reduxStoreTypes";
import AccordionElement from "./AccordionElement";

const Neighbours = ({ categoryId }: { categoryId: number | null }) => {
	const dispatch: any = useDispatch();
	const getList = useSelector(() => getNearestList);
	const nearestList = useSelector((state: StateType) => state.categoryData.nearestList);
	const location = useLocation();
	const { i18n } = useTranslation();
	const languagePath = i18n.language === "ru" ? "" : "ua/";
	const [title, setTitle] = useState("");

	useEffect(() => {
		if (categoryId) {
			dispatch(getList(categoryId));
		}
	}, [categoryId, location.pathname]);

	useEffect(() => {
		if (nearestList && nearestList.length > 0 && nearestList[0].tree?.length > 0) {
			const lastIndexOfTree = nearestList[0].tree?.length - 1;
			setTitle(
				(i18n.language === "ru"
					? nearestList[0]?.tree[lastIndexOfTree - 1]?.name_ru
					: nearestList[0]?.tree[lastIndexOfTree - 1]?.name) || ""
			);
		}
	}, [nearestList]);

	const linkGenerator = (item: CategoryWithTree) => {
		if (item.filter_link) {
			return item.filter_link;
		} else if (item.links_data) {
			let categoriesSlugs = item.links_data.tree
				.map((item, index) => (index === 1 ? `c2/${item}` : item))
				.join("/");
			if (item.links_data.tree.length < 4) {
				categoriesSlugs = categoriesSlugs.concat("/", item.links_data.realCatAlias || "");
			}
			return `/${languagePath}c/${categoriesSlugs}`;
		} else if (item.tree.length > 0 && !item.filter_link && !item.links_data) {
			let categoriesSlugs = item.tree
				.map((item, index) => (index === 1 ? `c2/${item.alias}` : item.alias))
				.join("/");
			if (item.tree.length < 4) {
				categoriesSlugs = categoriesSlugs.concat("/", item.alias || "");
			}
			return `/${languagePath}c/${categoriesSlugs}`;
		} else {
			return `/${languagePath}c`;
		}
	};

	return (
		<>
			{nearestList && nearestList?.length > 0 && (
				<AccordionElement title={title}>
					<ul className={s.linksContainer}>
						{nearestList?.map((item: CategoryWithTree) => (
							<li className={s.linkItem} key={`interlinkSettlements_${item.id}`}>
								<Link to={linkGenerator(item)} onClick={() => scrollToTop()}>
									{item.name}
								</Link>
							</li>
						))}
					</ul>
				</AccordionElement>
			)}
		</>
	);
};

export default Neighbours;
